// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","header2":"Header_header2__2ueqi","logo":"Header_logo__UsziS","login":"Header_login__12HCT"};